module.exports = __webpack_public_path__ + "7e4b29ba/img/grid-web-icon.d0395d64.svg";